import React, { createContext, useContext, useState, useEffect } from 'react';
import { getApiDetailsByProvider, getAssistantDetails, websiteProviderConn } from './ProviderDetails';
import { checkMicrophonePermission, getRetelllToken } from '../../Common/Appcommon';

const CallContext = createContext();

export const useWebCallContext = () => useContext(CallContext);

export const WebCallContextProvider = ({ children }) => {

    const [proCon, setProviderConnection] = useState(null);
    const [apiInfo, setApiInfo] = useState({});
    const [proName, setProName] = useState("");
    const [isCallStarted, setIsCallStarted] = useState(false);
    const [transcript, setTranscript] = useState([]);
    const [showTranscript, setShowTranscript] = useState(true);
    const [error,setError] = useState(true);
    useEffect(() => {
        const fetchData = async () => {

        }
        fetchData();
    }, []);

    useEffect(() => {
        if (!proCon) return;
        const handleMessage = (msg) => {
            if (msg.type !== "transcript") return;

            const role = msg.role === "assistant" ? "agent" : msg.role === "user" ? "user" : msg.role;
            const message = msg.transcript;
            const isFinal = msg.transcriptType === "final";

            setTranscript(prevTranscript => {
                const updated = [...prevTranscript];
                const lastIndex = updated.length - 1;

                if (
                    updated[lastIndex] &&
                    updated[lastIndex].role === role &&
                    !updated[lastIndex].isFinal
                ) {
                    updated[lastIndex] = { role, content: message, isFinal };
                } else {
                    updated.push({ role, content: message, isFinal });
                }

                return updated;
            });
        };
        if(proName == 'vapi'){
            proCon.on("message", handleMessage);
            proCon.on('error', (e) => {
                setError(true);
                let error = e.error !== undefined && e.error !== null ? (e.error.blockedMedia !== undefined && e.error.blockedMedia !== null ? e.error.blockedMedia[0] + " " +e.error?.msg?.toLowerCase(): e.error?.message?.toLowerCase()) : "Unable to talk right now.";
                // console.log("ERROR" , error)
            })
            proCon.on("call-start", () => {
                setIsCallStarted(true);
            });
            proCon.on("call-end", () => {
                setError(true);
            });
        }else if(proName == "retell"){
            proCon.on("update", (msg) => {
                setTranscript(msg.transcript);
            });
            proCon.on("call_started", () => {
                setIsCallStarted(true);
            });
            proCon.on("call_ended", () => {
                setError(true);
            });
            proCon.on("error", (error) => {
                console.log("ERROR" , error)
                setError(true);
            });
        }

    }, [proCon]);
    const startCall = async (rowData, apiDetails) => {
        let providerName = apiDetails['provider'];
        setApiInfo(apiDetails);
        setProName(providerName);
        let providerDetails = apiDetails['providerDetails'];
        //if (await checkMicrophonePermission()) {
            try {
                let providerCon = await websiteProviderConn(providerName, providerDetails);
                if (providerName !== "bland" && providerCon === "") {
                    //showToast(translateContent("vm.agents.call.error"), 'top-right', 'error');
                    return;
                }
                let agentId = rowData['Agent_ID'];
                if (providerName === "vapi") {
                    let pubKey = getApiDetailsByProvider(providerName, providerDetails);
                    let agentDetails = await getAssistantDetails(pubKey, agentId, providerName);
                    if (agentDetails !== null) {
                        initiateVapiCall(providerCon, agentId);
                    }
                } else if (providerName = "retell") {
                    let apiKey = getApiDetailsByProvider(providerName, providerDetails);
                    let agentDetails = await getAssistantDetails(apiKey, agentId, providerName);
                    if (agentDetails != null) {
                        initiateRetailsAiCall(providerCon, agentId, providerDetails);
                    }
                }
                setProviderConnection(providerCon);
            } catch (error) {
                console.log("error: ", error);
            }
        //} else {
            //showToast(translateContent("vm.agents.permission.error"), 'top-right', 'error');
       //}

    };

    const initiateVapiCall = (proCon, agentId) => {
        try {
            proCon.start(agentId);
        } catch (error) {
            setIsCallStarted(false);
            console.error("Error during Vapi call:", error.message || error);
        }
    }

    const initiateRetailsAiCall = async (proCon, agentId, apiDetails) => {
        try {
            let apiKey = getApiDetailsByProvider('retell',apiDetails);
            let res = await getRetelllToken(apiKey, agentId);
            if (res.issuccess) {
                let retailsDetails = res.data;
                let retellToken = retailsDetails['access_token'];
                retryWithBackoff(() => proCon.startCall({ accessToken: retellToken }));
            } else {
                //showToast(translateContent("vm.agents.token.error"), 'top-right', 'error');
            }
        } catch (error) {
            console.error("Error during Retail AI call:", error.message || error);
        }
    }

    const retryWithBackoff = async (fn, retries = 3, delay = 1000) => {
        for (let i = 0; i < retries; i++) {
            try {
                return await fn();
            } catch (err) {
                if (i === retries - 1) throw err;
                console.warn(`Retrying in ${delay}ms...`);
                await new Promise(res => setTimeout(res, delay));
                delay *= 2; // Exponential backoff
            }
        }
    };

    const initiateBlandCall = (proCon) => {
        proCon.initConversation({
            sampleRate: 44100
        })
            .then(() => {
                setIsCallStarted(true);
            })
            .catch((error) => {
                setIsCallStarted(false);
                console.error('Error initiating call:', error);
            });
    }

    const stopCall = () => {
        let providerName = proName;//getSessionValue("agent_provider_name");
        if (providerName === "vapi") {
            proCon.stop();
        } else if (providerName === "bland") {
            proCon.stopConversation();
        } else if (providerName === "retell") {
            proCon.stopCall();
        }
    };

    return (
        <CallContext.Provider value={{ 
            startCall,
            stopCall,
            isCallStarted,
            setIsCallStarted,
            transcript,
            setTranscript,
            showTranscript,
            setShowTranscript,
            error,
            setError,
        }}>
            <div className={""}>{children}</div>
        </CallContext.Provider>
    );
}
